<template>
  <b-modal v-model="showModal" size="sm" centered body-class="p-0" hide-footer>
    <span slot="modal-title">
      <small>{{ name }} </small>
    </span>
    <img :src="image" class="card-img" alt="img" />
  </b-modal>
</template>
<script>
export default {
  name: 'ModalPaymentQR',
  props: {
    image: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  watch: {
    name(value) {
      if (value) {
        this.showModal = true;
      }
    }
  }
};
</script>
